import { Component, Input } from '@angular/core';
import {
  SoftwareSelectionResolutionDto,
  THIRD_PARTY_SOFTWARE_SELECTION_REASONS,
} from 'src/app/models/device.model';

@Component({
  selector: 'app-device-software-overrides-summary',
  templateUrl: './device-software-overrides-summary.component.html',
  styleUrls: ['./device-software-overrides-summary.component.scss'],
  standalone: false,
})
export class DeviceSoftwareOverridesSummaryComponent {
  @Input() softwareSelectionResolutions:
    | SoftwareSelectionResolutionDto[]
    | null
    | undefined = [];
  @Input() supportedComponentIds: string[] = [];

  get effectiveSelectionCount(): number {
    const supportedComponentIds = new Set(this.supportedComponentIds);
    return (this.softwareSelectionResolutions ?? []).filter(
      (resolution) =>
        !!resolution?.component &&
        (supportedComponentIds.size === 0 ||
          (!!resolution.component.id &&
            supportedComponentIds.has(resolution.component.id)) ||
          (!!resolution.selectionReason &&
            THIRD_PARTY_SOFTWARE_SELECTION_REASONS.has(
              resolution.selectionReason,
            ))),
    ).length;
  }
}
